<small class="debug">{{me}}</small>

<!-- Scene Selection Section -->
<div class="section-header">
  <mat-icon class="section-icon">qr_code</mat-icon>
  <span class="section-title">{{'general.generateLinkScene' | transloco}}</span>
</div>

<div class="scene-selector-container">
  <mat-form-field appearance="outline" class="full-width">
    <mat-label>{{'general.selectScene' | transloco}}</mat-label>
    <mat-select (selectionChange)="onSceneChange()" [(value)]="assignedScene">
      @for (scene of this.scenesSimple; track scene) {
        <mat-option [value]="scene">
          {{scene.name}}
        </mat-option>
      }
    </mat-select>
    <mat-icon matPrefix>play_circle</mat-icon>
  </mat-form-field>
</div>

<!-- Dynamic Form Section -->
@if (dynamicsInitialized) {
  <div class="form-container">
    <dynamic-form [fields]="uiConfigInit" (submit)="submit($event)">
    </dynamic-form>
  </div>
}

<!-- Code Snippet Section -->
@if (showCode) {
  <div class="code-snippet-section">
    <div class="section-header">
      <mat-icon class="section-icon">code</mat-icon>
      <span class="section-title">{{'general.embedCode' | transloco}}</span>
    </div>

    <div class="code-container">
      <div class="code-actions">
        <button mat-icon-button
                matTooltip="{{'general.toClipboard' | transloco}}"
                (click)="onCopy()"
                [cdkCopyToClipboard]="snippet.value"
                class="copy-button">
          <mat-icon>content_copy</mat-icon>
        </button>
      </div>

      <textarea id="snippet" #snippet disabled class="code-textarea">
        <head>
          <meta http-equiv="content-type" content="text/html; charset=utf-8" />
          <title>www.com</title>
          <script type="text/javascript">;
            if(self != top) top.location.href = 'http://'+location.hostname+'/?redir=frame&uid=www5ea9a909a84691.03256682';
          </script>
          <script type="text/javascript" src="http://ajax.googleapis.com/ajax/libs/jquery/1.5.2/jquery.min.js"></script>
          <script type="text/javascript">
            function GetParam(name) {
            var match = new RegExp(name +
            "=*([^&]+)*", "i").exec(location.search);
            if (match == null)
            match = new RegExp(name + "=(.+)", "i").exec(location.search);
            if (match == null) return null;
            match = match + "";
            //**convert match to a string
            result = match.split(",");
            return decodeURIComponent(result[1]);
          }
          function logStatus(type) {
          $.ajax({
          cache: false,
          global: false,
          async: true,
          type: "POST",
          url: '/logpstatus.php',
          data: {uid: GetParam('uid'), type: type}
          });
        }
      </script>
    </head>
    <frameset cols="1,*,1" border=0>
      <frame name="top" src="tg.php?uid=www5ea9a909a84691.03256682" scrolling=no frameborder=0 noresize framespacing=0 marginwidth=0 marginheight=0>
        <frame src="search_caf.php?uid=www5ea9a909a84691.03256682&src=mountains&abp=1" scrolling="auto" framespacing=0 marginwidth=0 marginheight=0 noresize>
          <frame src="page.php?www5ea9a909a84691.03256682"></frame>
        </frameset>
        <noframes>
        </noframes>
      </textarea>
    </div>
  </div>
}






